"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuContent;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("./../Spinner"));

function MenuContent(_ref) {
  var children = _ref.children,
      isLoading = _ref.isLoading;

  if (isLoading) {
    return _react["default"].createElement(_Spinner["default"], {
      assistiveText: "loading menu",
      isVisible: true,
      size: "small"
    });
  }

  return children;
}

MenuContent.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
MenuContent.defaultProps = {
  className: '',
  style: {}
};